<template lang='pug'>
v-card(xs12).card-style
  v-snackbar(:value='newLeadsError', color='error')
    div {{ newLeadsErrorMessage }}
  v-flex
    v-flex.centered.title-style NEW LEADS GENERATED
    v-flex.centered New leads generated with your Leads+ subscription.
  v-flex.centered
    canvas.chart(id="new-leads-chart" width="1000" height="1000" ref="canvas")
    v-flex.pa-0.ma-0.loadingDialog(v-if="newLeadsInProgress") Loading...
</template>
          
<script>
import { createNamespacedHelpers } from 'vuex';
import Chart from 'chart.js/auto';

const { mapGetters: mapQualifyGetters } = createNamespacedHelpers('qualify');
const { mapGetters: mapLeadsplusGetters } = createNamespacedHelpers('leadsplus');
const { mapActions: mapReportingActions, mapState: mapReportingState } = createNamespacedHelpers('reportingQualify');
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
let chart;

export default {
  name: 'NewLeadsWidget',
  data() {
    return {
      graphData: [],
      graphLabels: [],
      graphColors: ['rgb(82,158,235)'],
    }
  },
  computed: {
    ...mapQualifyGetters(['isIntegrationConnected']),
    ...mapLeadsplusGetters({ isLeadsplusIntegrationConnected: 'isIntegrationConnected' }),
    ...mapReportingState(['newLeadsDates', 'newLeadsCounts', 'newLeadsInProgress', 'newLeadsError', 'newLeadsErrorMessage']),
    watchedValue() {
      return `${this.graphData}|${this.graphLabels}`;
    }
  },
  created() {
    this.getWidgetData();
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    watchedValue: {
      handler() {
        this.renderChart();
      }
    },
    isLeadsplusIntegrationConnected: {
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    ...mapReportingActions(['getNewLeadsQualify']),
    async getWidgetData() {
      if (!this.isLeadsplusIntegrationConnected) {
        this.loadMockData();
        return;
      }

      if (!this.isIntegrationConnected || this.newLeadsInProgress) {
        this.loadEmptyData();
        return;
      }

      const dates = this.getSixMonthWindow();
      const querySettings = { leadsource: 'leadsplus', ...dates };
      await this.getNewLeadsQualify(querySettings);
      this.loadRealData();
    },
    loadMockData() {
      this.graphLabels = ['2022-07-01', '2022-08-01', '2022-09-01', '2022-10-01', '2022-11-01', '2022-12-01'];
      this.graphData = [20, 40, 5, 5, 15, 10];
    },
    loadRealData() {
      this.graphLabels = this.newLeadsDates;
      this.graphData = this.newLeadsCounts;
    },
    loadEmptyData() {
      this.graphLabels = [];
      this.graphData = [];
    },
    formatData() {
      var formattedLabels = [];
      for (var i = 0; i < this.graphLabels.length; i++) {
        var date = new Date(this.graphLabels[i]);
        formattedLabels.push(months[date.getUTCMonth()]);
      }
      return { 'labels': formattedLabels, 'data': this.graphData, 'colors': this.graphColors }
    },
    async renderChart() {
      await this.getWidgetData();
      var formatted = await this.formatData();
      var flabels = formatted.labels;
      var fdata = formatted.data;
      var fcolors = formatted.colors;

      var dataset = {
        data: fdata,
        backgroundColor: fcolors
      }

      if (chart !== undefined) chart.destroy();

      chart = new Chart(document.getElementById('new-leads-chart').getContext('2d'), {
        type: 'bar',
        data: {
          labels: flabels,
          datasets: [dataset],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scale: {
            ticks: {
              precision: 0
            }
          }
        },
      });
    },
    getSixMonthWindow() {
      const today = new Date();
      var year = today.getUTCFullYear();
      var month = today.getUTCMonth();
      var startDate = new Date(year, month - 5, 1);
      var endDate = new Date(year, month + 1, 0);
      return { startDate: startDate.toISOString().split('T')[0], endDate: endDate.toISOString().split('T')[0] }
    }
  },
}
</script>
        
<style lang="scss" scoped>
.card-style {
  padding: 15px;
  height: 100%;
}

.centered {
  display: flex;
  justify-content: center;
}

.title-style {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.chart {
  max-height: 350px;
}

.loadingDialog {
  position: absolute;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  font-weight: bold;
  font-size: 16px;
}
</style>
